module.exports = __webpack_public_path__ + "img/passportau.26c39c07.png";